import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Menu, X, Truck } from "lucide-react";

const links = [
  { label: "Services", href: "/#services" },
  { label: "How It Works", href: "/#how-it-works" },
  { label: "Service Area", href: "/#service-area" },
  { label: "Blog", href: "/blog" },
  { label: "Book", href: "/#booking" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";
  const solid = scrolled || !isHome;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        solid ? "bg-white/85 backdrop-blur-xl border-b border-black/5" : "bg-transparent"
      }`}
    >      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <a href="/#top" data-testid="logo" className="flex items-center gap-2.5 group">
            <div className="bg-primary p-2 rounded-sm">
              <Truck className="w-5 h-5 text-white" strokeWidth={2.5} />
            </div>
            <div className="leading-none">
              <span
                className={`block font-black text-lg tracking-tighter transition-colors ${
                  solid ? "text-foreground" : "text-white"
                }`}
                style={{ fontFamily: "Inter" }}
              >
                F1 FLEET
              </span>
              <span
                className={`block text-[10px] font-bold uppercase tracking-[0.2em] transition-colors ${
                  solid ? "text-muted-foreground" : "text-white/60"
                }`}
              >
                Maintenance
              </span>
            </div>
          </a>

          <nav className="hidden md:flex items-center gap-8">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className={`text-sm font-semibold hover:text-primary transition-colors duration-200 ${
                  solid ? "text-foreground/80" : "text-white/90"
                }`}
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-4">
            <a
              href="tel:+14046356669"
              data-testid="nav-phone"
              className={`text-sm font-bold font-mono hidden lg:block transition-colors ${
                solid ? "text-foreground" : "text-white"
              }`}
            >
              (404) 635-6669
            </a>
            <a
              href="/#booking"
              data-testid="nav-book-cta"
              className="bg-primary text-white px-5 py-2.5 text-sm font-bold uppercase tracking-wide rounded-sm hover:bg-secondary transition-colors duration-300"
            >
              Book Service
            </a>
          </div>

          <button
            data-testid="mobile-menu-toggle"
            aria-label="Toggle navigation menu"
            className={`md:hidden p-2 ${solid ? "text-foreground" : "text-white"}`}
            onClick={() => setOpen(!open)}
          >
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-white border-t border-black/5 px-4 py-4 space-y-3">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="block text-sm font-semibold py-2"
            >
              {l.label}
            </a>
          ))}
          <a
            href="/#booking"
            onClick={() => setOpen(false)}
            className="block bg-primary text-white text-center px-5 py-3 text-sm font-bold uppercase rounded-sm"
          >
            Book Service
          </a>
        </div>
      )}
    </header>
  );
};
